import { widgetQuickSettingBar } from './quick-setting-bar/index.js';
import { createWidgetTools, toolsWidgetPresets } from './tools/index.js';
import { widgetViewsBar } from './views-bar/index.js';

export { openDatabaseBulkUploadPicker } from './tools/presets/bulk-upload/bulk-upload.js';
export { popViewOptions } from './tools/presets/view-options/view-options.js';

export const widgetPresets = {
  viewBar: widgetViewsBar,
  quickSettingBar: widgetQuickSettingBar,
  createTools: createWidgetTools,
  tools: toolsWidgetPresets,
};
